import { DatePipe, DecimalPipe } from '@angular/common';
import {
  Component,
  OnInit,
  WritableSignal,
  signal,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ChartModule } from '@openng/optimus-ui/chart';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { PIValue } from 'src/app/model/operational-monitoring/pi-value';
import { OperationalMonitoringApiService } from 'src/app/services/api/operational-monitoring-api.service';
import { ProgressSpinnerComponent } from '../../../core/components/progress-spinner.component';

@Component({
  selector: 'app-pi-value-display',
  imports: [
    ProgressSpinnerComponent,
    DialogModule,
    ChartModule,
    DatePipe,
    DecimalPipe,
  ],
  templateUrl: './pi-value-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pi-value-display.component.scss',
})
export class PiValueDisplayComponent implements OnInit {
  private _opMonApi = inject(OperationalMonitoringApiService);

  readonly piPoint = input<string>();

  loading: WritableSignal<boolean> = signal(true);
  plotLoading: WritableSignal<boolean> = signal(true);
  piValue: WritableSignal<PIValue | null> = signal(null);
  hours: WritableSignal<number> = signal(6);
  showChartDialog: boolean = false;
  piPlotData: PIValue[] = [];
  chartData = {};
  chartOptions = {
    parsing: {
      xAxisKey: 'timestamp',
      yAxisKey: 'value',
    },
  };

  ngOnInit(): void {
    this.loadPIValue();
  }

  loadPIValue(): void {
    this.loading.set(true);
    this._opMonApi.getLatestPIValue(this.piPoint()!).subscribe({
      next: (piValue) => {
        this.piValue.set(piValue);
        this.loading.set(false);
      },
      error: (error) => {
        console.error(error);
        this.loading.set(false);
      },
    });
  }

  loadPIPlotData(): void {
    this.plotLoading.set(true);
    this.piPlotData = [];
    this._opMonApi.getPIValuePlot(this.piPoint()!, this.hours()).subscribe({
      next: (piPlotData) => {
        this.piPlotData = piPlotData;
        this.buildChartData();
        this.plotLoading.set(false);
      },
      error: (error) => {
        console.error(error);
        this.plotLoading.set(false);
      },
    });
  }

  openChartDialog(): void {
    this.loadPIPlotData();
    this.showChartDialog = true;
  }

  onChartHide(): void {
    this.showChartDialog = false;
  }

  buildChartData(): void {
    this.chartData = {
      datasets: [
        {
          label: this.piPoint(),
          backgroundColor: '#0e406a',
          borderColor: '#0e406a',
          data: this.piPlotData.map((piValue) => {
            return {
              timestamp: piValue.timestamp.toLocaleTimeString(),
              value: piValue.value,
            };
          }),
        },
      ],
    };
  }
}
